import React from 'react'

import { Trash2 as Trash2Icon } from 'react-feather'
import { TableContainer, IconButton } from '@material-ui/core'
import { isEmpty } from 'lodash'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'

import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import helpers from 'helpers'

const CompanySupplierAuditUserTable = ({
  questionnaireUsers,
  refresh,
  refreshQuestionnaires,
  setIsLoading,
}) => {
  const snackbar = useSnackbar()

  const handleRemove = async ({ companySupplierAuditUserId, id }) => {
    try {
      setIsLoading(true)

      await service.supplierPortal.companySupplierQuestionnaireUsers.destroy({
        companySupplierAuditUserId,
        id,
      })

      snackbar.open({
        message: 'Vinculo de usuário com questionários cancelado com sucesso.',
        variant: 'success',
      })

      refresh()
      refreshQuestionnaires()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao desvincular usuário de questionário',
        variant: 'error',
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>E-mail</TableCell>
            <TableCell>Questionário(s)</TableCell>
            <TableCell align="right">Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isEmpty(questionnaireUsers) ? (
            <TableRow>
              <TableCell colSpan={4}>Nenhum vínculo encontrado.</TableCell>
            </TableRow>
          ) : (
            questionnaireUsers?.map((questionnaireUser) => (
              <TableRow key={questionnaireUser?.id}>
                <TableCell>{questionnaireUser?.id}</TableCell>
                <TableCell>{questionnaireUser?.user?.email}</TableCell>
                <TableCell>{questionnaireUser?.questionnaire?.kind}</TableCell>
                <TableCell align="right">
                  <IconButton
                    onClick={() =>
                      handleRemove({
                        companySupplierAuditUserId:
                          questionnaireUser?.companySupplierAuditUser?.id,
                        id: questionnaireUser?.id,
                      })
                    }
                    disabled={!questionnaireUser?.canEdit}
                  >
                    <Trash2Icon size={18} />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default CompanySupplierAuditUserTable
